import { Component, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { ResultadoPcPage, TabsPage, ResultadoBotPage } from '@pages';
import { Pregunta } from '@domain/pregunta';
import { Jugador } from '@domain/jugador';
import { DesafioPersonalProvider } from '@providers/desafio-personal/desafio-personal';
import * as moment from 'moment';
import * as arrayShuffle from 'array-shuffle';
import { ASSETS } from '@env';
import { Equipo } from '@domain/equipo';
import { LoadingProvider } from '@providers/loading/loading';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-reto-pc',
  templateUrl: 'reto-pc.html',
})
export class RetoPcPage implements AfterViewInit {

  ICONS_CATEGORIES = ASSETS.ICONS_CATEGORIES;
  IMAGE_QUESTIONS = ASSETS.IMAGE_QUESTIONS;

  esIncorrecto = false;
  esCorrecto = false;
  checked = 0;
  disabled = false;

  bot: any;
  juego: any;
  pregunta: Pregunta = new Pregunta;
  jugador: Jugador = new Jugador;

  resultados: any = {
    jugador: '',
    totalCorrectas: 0,
    totalIncorrectas: 0,
    estadisticas: []
  };

  tiempoInicio: any;
  tiempoRespuesta: string;
  tiempoRespuestaAray: Array<any>;

  readonly PUNTOS_RESPUESTA_CORRECTA = 10;
  readonly PUNTOS_POR_TIEMPO = 2;
  readonly TIEMPO_PARA_RESPONDER = 10;

  readonly AUDIO_OK = 'assets/audios/resp_correcta.wav';
  readonly AUDIO_ERROR = 'assets/audios/resp_wrong.wav';

  puntosGanados = 0;
  private audio = new Audio();

  equipo: Equipo = new Equipo;

  @ViewChild('timer', { read: ElementRef }) timer: ElementRef;

  imageIsLoaded: boolean = false;
  indexOptionSelected: number;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private cdRef: ChangeDetectorRef,
    private loadingProvider: LoadingProvider,
    private desafioPersonalProvider: DesafioPersonalProvider,
    private alertCtrl: AlertController,
    private translateService: TranslateService,
  ) {
    this.juego = navParams.get('juego');
    this.jugador = navParams.get('jugador');
    this.equipo = navParams.get('equipo');
    this.bot = navParams.get('bot');

    if(!this.juego) {
      this.juego = {...this.bot};

      const start = (this.bot.rondaActual - 1) * (this.bot.preguntas.length / this.bot.totalRondas);
      const end  = (this.bot.preguntas.length / this.bot.totalRondas) * this.bot.rondaActual ;
      
      this.juego.preguntas = this.juego.preguntas.slice(start, end);
    }
  }

  ionViewDidLoad() {
  }

  validaPregunta(esValida: boolean, pregunta: any, index: number) {
    this.indexOptionSelected = index;
    this.esCorrecto = esValida;
    this.esIncorrecto = !esValida;
    this.disabled = true;
    this.timer.nativeElement.style.animationPlayState = 'paused';
    this.puntosGanados = 0;
    this.obtenTiempoRespuesta();

    if (esValida) {
      this.resultados.totalCorrectas++;
      this.calculaPuntos();

      this.audio.src = this.AUDIO_OK;

    } else {
      this.resultados.totalIncorrectas++;
      this.audio.src = this.AUDIO_ERROR;
    }

    this.audio.load();
    this.audio.play();

    let tiempo: any = (+this.tiempoRespuestaAray[0] * 60) + (+this.tiempoRespuestaAray[1]);
    tiempo = tiempo + '.' +  (+this.tiempoRespuestaAray[2]);

    this.resultados.estadisticas.push({
      pregunta: pregunta._id,
      tiempo: +tiempo,
      puntos: this.puntosGanados,
      esCorrecta: esValida
    });

    if(!this.bot) {
      this.desafioPersonalProvider.setEstadisticasRonda(this.resultados);
    }
    
  }

  async guardaRonda() {
    this.loadingProvider.show(true);
    try {
      const response = await this.desafioPersonalProvider.actualiza(this.juego.desafio, this.resultados, this.equipo.area._id);
      
      this.desafioPersonalProvider.clearRondaActual();
      this.loadingProvider.show(false);

      return this.navCtrl.setRoot(ResultadoPcPage, {
        juego: this.juego,
        jugador: this.jugador,
        estatus: response
      });
    } catch (error) {
      this.loadingProvider.show(false);
      this.desafioPersonalProvider.clearRondaActual();

      return this.navCtrl.setRoot(ResultadoPcPage, {
        juego: this.juego,
        jugador: this.jugador,
        estatus: this.buildLocalResponse()
      });
    }

    // this.desafioPersonalProvider.actualiza(this.juego.desafio, this.resultados, this.equipo.area._id)
    //   .then(response => {
    //     this.desafioPersonalProvider.clearRondaActual();
    //     this.loadingProvider.show(false);

    //     return this.navCtrl.setRoot(ResultadoPcPage, {
    //       juego: this.juego,
    //       jugador: this.jugador,
    //       estatus: response
    //     });
    //   })
    //   .catch( _ => {
    //     this.loadingProvider.show(false);
    //     this.desafioPersonalProvider.clearRondaActual();

    //     return this.navCtrl.setRoot(ResultadoPcPage, {
    //       juego: this.juego,
    //       jugador: this.jugador,
    //       estatus: this.buildLocalResponse()
    //     });
    //   })
  }

  buildLocalResponse() {
    return {
      "estatus": 0,
      "siguienteRonda": false,
      "desafio": {
        "area": this.equipo.area._id,
        "totalRondas": this.juego.rondaActual,
        "preguntasPorRonda": this.juego.totalRondas,
        "rondas": [
          {
            "setPreguntas": this.juego.preguntas,
            "numeroRonda": this.juego.rondaActual,
            "jugador1": {
              "jugador": this.jugador._id,
              "totalCorrectas": this.resultados.totalCorrectas,
              "totalIncorrectas": this.resultados.totalIncorrectas,
              "estadisticas": this.resultados.estadisticas
            }
          }
        ]
      }
    }
  }

  showAlert() {
   const alert = this.alertCtrl.create({
     title: this.translateService.instant('personalChallenge.showAlert.title') ,
     subTitle: this.translateService.instant('personalChallenge.showAlert.subTitle'),
     buttons: [
       {
        text: this.translateService.instant('personalChallenge.showAlert.text'),
        handler: () => {
          this.navCtrl.setRoot(TabsPage, {
            active: 0
          });
        }
      }
     ]
   });
   alert.present();
 }

  siguiente() {
    this.indexOptionSelected = -1;
    let siguientePregunta = this.juego.preguntas.pop();

    if (!siguientePregunta) {
      if(!this.bot) {
        this.guardaRonda();
      } else {
        if(this.bot.estadisticas && this.bot.estadisticas.length > 0) {
          this.bot.estadisticas = this.bot.estadisticas.concat(this.resultados.estadisticas);
        } else {
          this.bot.estadisticas = this.resultados.estadisticas;
        }        

        return this.navCtrl.setRoot(ResultadoBotPage, {
          bot: this.bot,
          jugador: this.jugador,
          resultado: this.resultados,
          equipo: this.equipo
        });
      }

    } else {

      this.imageIsLoaded = !siguientePregunta.requiereImagen;

      let _arrayOpciones = [
        siguientePregunta.opcion1,
        siguientePregunta.opcion2,
        siguientePregunta.opcion3,
        siguientePregunta.opcion4,
      ];
      siguientePregunta.opciones = arrayShuffle(_arrayOpciones);
      siguientePregunta.opciones = arrayShuffle(siguientePregunta.opciones);

      this.tiempoInicio = moment();
      this.pregunta = siguientePregunta;
      this.esIncorrecto = false;
      this.esCorrecto = false;
      this.checked = 0;
      this.disabled = false;
      this.tiempoRespuesta = '';
      this.timer.nativeElement.style.animationPlayState = '';
      this.timer.nativeElement.style.animation = '';

      if(this.imageIsLoaded){
        this.iniciaCounterBack();
      }

    }
  }

  iniciaCounterBack() {
    setTimeout(() => {
      this.timer.nativeElement.style.animation = 'countdown ' + this.TIEMPO_PARA_RESPONDER + 's linear  forwards';
    });
  }

  async ngAfterViewInit() {
    const estadisticas = await this.desafioPersonalProvider.getEstadisticasRonda()
    
    if(estadisticas) {
      this.resultados = estadisticas;
      this.juego.preguntas = this.juego.preguntas.filter( p => !this.resultados.estadisticas.find( e =>  e.pregunta == p._id) );
    }

    this.resultados.jugador = this.jugador._id;

    this.siguiente();
  }

  obtenTiempoRespuesta() {
    let now = moment();
    let then = this.tiempoInicio;

    let time = moment.utc(moment(now, "DD/MM/YYYY HH:mm:ss.S").diff(moment(then, "DD/MM/YYYY HH:mm:ss.S"))).format("m.s.S");
    this.tiempoRespuestaAray = time.toString().split('.');

    this.tiempoRespuesta = +this.tiempoRespuestaAray[0] === 0 ?
      this.tiempoRespuestaAray[1] + '.' + this.tiempoRespuestaAray[2] + 's' :
      this.tiempoRespuestaAray[0] + '.' + this.tiempoRespuestaAray[1] + 'm';

  }

  calculaPuntos() {
    this.puntosGanados = this.PUNTOS_RESPUESTA_CORRECTA;

    let m = +this.tiempoRespuestaAray[0];
    let s = +this.tiempoRespuestaAray[1];
    let ss = +this.tiempoRespuestaAray[2];

    let total = ((m * 60) + s) + (ss * .10);

    const fraccion = this.TIEMPO_PARA_RESPONDER / 4;

    if (total >= 0 && total < fraccion) {
      this.puntosGanados += this.PUNTOS_POR_TIEMPO * 4;
    }

    if (total >= fraccion && total < fraccion * 2) {
      this.puntosGanados += this.PUNTOS_POR_TIEMPO * 3;
    }

    if (total >= fraccion * 2 && total < fraccion * 3) {
      this.puntosGanados += this.PUNTOS_POR_TIEMPO * 2;
    }

    if (total >= fraccion * 3 && total < fraccion * 4) {
      this.puntosGanados += this.PUNTOS_POR_TIEMPO;
    }
  }

  imageLoaded() {
    this.imageIsLoaded = true;
    this.iniciaCounterBack();
    this.cdRef.detectChanges();
  }

}



// WEBPACK FOOTER //
// ./src/pages/personal-challenge/reto-pc/reto-pc.ts